import React from 'react';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';

import { fetchMarketplaceData } from '../../../dataFetchers/marketplaceDataFetcher';
import { getBECompatibleLocale, getBECompatibleFuelType } from '../../../helpers/helper';
import Marketplace from './Marketplace';
import BCLLoading from '../../common/Loading/BCLLoading';
import RecommendationDetailsModal from '../recommendationsPage/RecommendationsTips/RecommendationDetailsModal';
import { PAGE_EVENT_NAMES } from '../../../constants/common';
import { trackEvent } from '../../../helpers/analyticsHelper';
import { queryRecoCardLoaded } from '../../../actions/recoDetailsActions';

class MarketplaceContainer extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            open: false,
            activeRecoId: null
        }
    }

    componentDidMount(){
        if(!this.props.marketplaceData.data){
            this.props.fetchMarketplaceData({
                uuid : this.props.userIdentityDetails.userId,
                locale : getBECompatibleLocale(this.props.configs.data),
                measurementType : getBECompatibleFuelType(this.props.configs.data['fuelType']),
                count : this.props.configs.data['DASHBOARD.MARKETPLACE.COUNT']
            })
        }
    }

    componentDidUpdate(){
        if(this.props.queryParams && this.props.queryParams.recoId && this.props.configs.data['dashboard.marketplace.productEducationEnabled'] === "true" && !this.props.recoDetailsData.queryCardLoaded){
            this.props.queryRecoCardLoaded();
            this.handleModal(this.props.queryParams.recoId);
        }
    }

    handleModal(recoId){
        let isModalOpen = this.state.open;
        this.setState({
            open: !isModalOpen,
            activeRecoId: recoId || null
        });

        //Track reco open/close event
            trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.MARKETPLACE, {
                recoID : recoId,
                open : !isModalOpen,
                close : isModalOpen
            }) 
    }
    
    handleCTAClick(recoId, link) {
        if(link){
            window.open(link);
        }else{
            this.handleModal(recoId);
        }
    }

    isFeatureEnabled(feature){
        return this.props.configs.data[`dashboard.marketplace.${feature}`] === "true";
    }


    openPurchaseLink(itemLink){
        window.open(itemLink);
    }

    render(){
        const selfInstallEnabled = this.isFeatureEnabled('selfInstallEnabled');
        const marketplaceCTAEnabled = this.isFeatureEnabled('marketplaceCTAEnabled');
        const marketPlaceInsightEnabled = this.isFeatureEnabled('insightsEnabled');
        const productEducationEnabled = this.isFeatureEnabled('productEducationEnabled');

        const insightBulbImage = this.props.configs.data["DASHBOARD.RECOMMENDATIONS.INSIGHTS_BULB"];

        return(
            <>
                <div className="marketplace-container">
                    {this.props.marketplaceData && this.props.marketplaceData.data ? 
                    <Marketplace marketplaceData={this.props.marketplaceData.data} selfInstallEnabled={selfInstallEnabled} 
                    translations={this.props.translations.data} marketplaceCTAEnabled={marketplaceCTAEnabled} applianceList={this.props.applianceList}
                    insightBulbImage={insightBulbImage} marketPlaceInsightEnabled={marketPlaceInsightEnabled} translations={this.props.translations}
                    productEducationEnabled={productEducationEnabled} handleCTAClick={(recoId, link) => this.handleCTAClick(recoId, link)} openPurchaseLink={(link)=>this.openPurchaseLink(link)}/> 
                    : this.props.marketplaceData.failed ? <div className="marketplace-title">{this.props.translations.data["DASHBOARD.MARKETPLACE.TITLE_FAILED"]}</div> : <BCLLoading/>}
                </div>
                {this.state.activeRecoId ?
                    <Dialog open={this.state.open} onClose={() => this.handleModal(null)} aria-labelledby="scroll-dialog-reco" maxWidth="lg">
                        <RecommendationDetailsModal onCloseClick={() => this.handleModal(null)} activeReco={this.state.activeRecoId} 
                        onRecoLike={(recoID, event) => this.handleRecoLikeUnlike(recoID, event)} onRecoUnlike={(recoID, event) => this.handleRecoLikeUnlike(recoID, event)}
                        marketplaceCTAEnabled={marketplaceCTAEnabled} openPurchaseLink={(link)=>this.openPurchaseLink(link)}/>
                    </Dialog>
                : ''}
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        userIdentityDetails: state.userIdentityDetails,
        configs: state.configs,
        translations: state.translationsData,
        queryParams: state.queryParams,
        marketplaceData : state.marketplaceData,
        applianceList: state.appliances.appliancesList,
        recoDetailsData : state.recoDetailsData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchMarketplaceData : (params) => dispatch(fetchMarketplaceData(params)),
        queryRecoCardLoaded : () => dispatch(queryRecoCardLoaded())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(MarketplaceContainer);
